import EventEmitter from 'events';
import config from '../config/index';
import { getProfile, getEduRole } from '../api/user';
import { refreshToken } from '@/api/user'
import { getToken, setToken, clearToken } from '../utils/tools';
import Cookies from '../utils/cookie';

import router from '../router.js'
import store from '../store/store.js'
import app from '../main.js'

class AuthService extends EventEmitter {
    profile = null;

    // Handles the callback request from Auth0
    handleAuthentication() {
        let that = this
        return new Promise((resolve, reject) => { 
            getProfile().then((res) => {
                that.localLogin(res.data)
                resolve(res.data)
            }, (err) => {
                alert(err + '. Detailed error can be found in console.');
                reject(err)
            })
        })
    }

    localLogin(authResult) {
        this.profile = authResult.info;
        
        localStorage.setItem('userRole', this.profile.user_role)
        localStorage.setItem('eduRole', this.profile.current_edu_role?this.profile.current_edu_role:'public')
        localStorage.setItem('roles', JSON.stringify(this.profile.roles))

        // Convert the JWT expiry time from seconds to milliseconds
        localStorage.setItem('userInfo', JSON.stringify({
            displayName: this.profile.nickname,
            username: this.profile.username,
            email: this.profile.email,
            phone: this.profile.phone,
            photoURL: this.profile.avatar,
            providerId: this.profile.id,
            uid: this.profile.id,
            motto: this.profile.motto,
            lastLoginTime: this.profile.last_login_time,
            roles: ['']
        }));
        if (this.profile.school_info != undefined) {
            store.dispatch('updateSchool', this.profile.school_info);
        }
        store.dispatch('updateEduRoles', this.profile.roles);
        store.dispatch('updateEduRole', this.profile.current_edu_role?this.profile.current_edu_role:'public');
        app.$acl.change(store.state.eduRole)
    
    }

    renewTokens() {
        let that = this
        // reject can be used as parameter in promise for using reject
        return new Promise((resolve, reject) => { 
            if (getToken()) {
                console.log('renew token')
                getProfile().then((res) => {
                    that.localLogin(res.data)
                    resolve(res.data)
                }, (err) => {
                    alert(err + '. Detailed error can be found in console.');
                    reject(err)
                })
            } 
        })
    }

    logOut() {
        localStorage.removeItem('userInfo');
        localStorage.removeItem('eduRole');
        this.profile = null;
    }

    isAuthenticated() {
        if (getToken()) {
            return true;
        } else {
            let refresh =  Cookies.get(config.refreshToken)
            if (refresh) {
                refreshToken({refresh_token: refresh}).then(res => {
                    if (res.code == 1 && res.data.token != '') {
                        setToken(res.data.token, res.data.expire)
                        location.reload()
                        return true
                    } else {
                        return false
                    }
                })
            }
            
        }
        return false
    }
}

export default new AuthService();
